import { expertiseActions } from '../actions';

export default function expertise ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case expertiseActions.SET_PROFILE_EXPERTISE: return generalExpertiseReducer( newState, action );
        case expertiseActions.GENERAL_EXPERTISE_SUCCESS: return generalExpertiseReducer( newState, action );
        case expertiseActions.CREATE_EXPERTISE: return generalExpertiseReducer( newState, action );
        case expertiseActions.CLEAR_EXPERTISE_REDUCER: return clearExpertiseReducer( newState, action );
        case expertiseActions.SET_EXPERTISE_REQUEST: return setExpertiseRequest( newState, action );
        default: return newState;
    }
}

function generalExpertiseReducer ( newState, action ) {
    delete action.type;
    return  Object.assign( newState, { ...action } );
}

function clearExpertiseReducer ( newState, action ) {
    delete action.type;
    return {
        ...newState,
        ...action
    };
}

function setExpertiseRequest ( newState, action ) {
    delete action.type;
    return {
        ...newState,
        ...action
    };
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/expertise.js